import { render, staticRenderFns } from "./General_Service.vue?vue&type=template&id=0bdb6d00&scoped=true&"
import script from "./General_Service.vue?vue&type=script&lang=js&"
export * from "./General_Service.vue?vue&type=script&lang=js&"
import style0 from "./General_Service.vue?vue&type=style&index=0&id=0bdb6d00&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb6d00",
  null
  
)

export default component.exports